import api from "services/api";

export async function getDadosSystem() {
  try {
    const response = await api.get("/types");
    return response.data;
  } catch (error) {
    throw new Error("Falha");
  }
}
